import {
    useMutation,
    useQuery,
} from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { Delete, Get, Post, Put } from "../api";
import API_CONSTANTS from "../constants/api";
import { appendQueryParams } from "../helpers/queryHelper";;

export const useCohortVariants = (params) => {
    const token = useSelector((state) => state.user?.token)
    return useQuery({
        queryKey: ["cohortVariants", params],
        queryFn: async () => {
            const { data } = await Get({
                path: `${API_CONSTANTS.COHORT_VARIANTS.base}?${appendQueryParams({params})}`,
                token,
                toastError: true
            })
            return data
        },
        keepPreviousData: true
    })
}

export const useCohortVariantsFacet = () => {
    const token = useSelector((state) => state.user?.token)
    return useQuery({
        queryKey: ["cohortVariantsFacet"],
        queryFn: async () => {
            const { data } = await Get({
                path: API_CONSTANTS.COHORT_VARIANTS.getFacet,
                token,
                toastError: true,
            })
            return data
        },
    })
}

export const useCohortVariantOptions = (params = {}) => {
    const token = useSelector((state) => state.user?.token)
    return useQuery({
        queryKey: ["cohortVariantOptions", params],
        queryFn: async () => {
            const { data } = await Get({
                path: `${API_CONSTANTS.COHORT_VARIANTS.getOptions}?${appendQueryParams({params})}`,
                token,
                toastError: true,
            })
            return data
        }
    })
}

export const useCreateCohortVariant = () => {
    const token = useSelector((state) => state.user?.token)
    return useMutation({
        mutationFn: async (body) => {
            const { data } = await Post({
                path: API_CONSTANTS.COHORT_VARIANTS.base,
                token,
                body
            })
            return data
        },
    })
}

export const useUpdateCohortVariant = (id) => {
    const token = useSelector((state) => state.user?.token)
    return useMutation({
        mutationFn: async (body) => {
            const { data } = await Put({
                path: `${API_CONSTANTS.COHORT_VARIANTS.base}/${id}`,
                token,
                body
            })
            return data
        },
    })
}

export const useDeleteCohortVariant = () => {
    const token = useSelector((state) => state.user?.token)
    return useMutation({
        mutationFn: async (id) => {
            const { data } = await Delete({
                path: `${API_CONSTANTS.COHORT_VARIANTS.base}/${id}`,
                token,
                toastError: true,
                toastMessage: true
            })
            return data
        },
    })
}